module.exports = __webpack_public_path__ + "static/media/social.3fb5a087.png";